import React, { Component } from 'react';
import { Form, Select, Button } from 'antd';
import NHFetch from "../../../../utils/NHFetch";
import { getLoginUser } from '../../../../utils/NHCore';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bmmcData: [],
      ssnjData: []
    };
  }
  componentDidMount() {
    const params = {
      sign: "zhxg_yxfw_swbl_lstdtj_final",
      initParams: {
        S_XSLBM_IN:this.props.xslbm
      },
      sqlParams: {
        userId: getLoginUser().userId
      },
      searchParams: {},
      searchTextMap: {},
      filters: {},
      pagination:{
        pageSize:100000,
        page:1
      }
    }
    NHFetch('/proData/gridList', 'POST', params).then(res => {
      if (res && res.code === 200) {
        let ssnjSet = new Set(res.data.list.map(item=>{
          return item.SSNJ
        }).filter(item=>item));
        let bmmcSet = new Set(res.data.list.map(item=>{
          return item.BMMC
        }).filter(item=>item));
        this.setState({
          bmmcData:[...bmmcSet],
          ssnjData:[...ssnjSet]
        })
      }
    })
  }
  search = () => {
    this.props.form.validateFields(async(err,values)=>{
      if (typeof this.props.onSearch === 'function') {
        let searchParams = {}
        for(let key in values) {
          if (values[key] && values[key].length > 0) {
            searchParams[key] = values[key]
          }
        }
        this.props.onSearch(searchParams);
      }
    })
  }
  reset = () => {
    this.props.form.resetFields();
    if (typeof this.props.onSearch === 'function') {
      this.props.onSearch({});
    }
  }
  render() {
    const { bmmcData, ssnjData } = this.state;
    const { getFieldDecorator } = this.props.form;
    const selectStyle = {
      width: '300px'
    }
    return (
      <Form layout='inline'>
        <Form.Item label='年级'>
          {
            getFieldDecorator('S_SSNJ_IN', {})(
              <Select style={selectStyle} mode='multiple'>
                {ssnjData.map(item => {
                  return <Select.Option key={item} value={item}>{item}</Select.Option>
                })}
              </Select>
            )
          }
        </Form.Item>
        <Form.Item label='学院'>
          {
            getFieldDecorator('S_BMMC_IN', {})(
              <Select style={selectStyle} mode='multiple'>
                {bmmcData.map(item => {
                  return <Select.Option key={item} value={item}>{item}</Select.Option>
                })}
              </Select>
            )
          }
        </Form.Item>
        <Form.Item>
          <Button type='primary' onClick={this.search}>查询</Button>
        </Form.Item>
        <Form.Item>
          <Button onClick={this.reset}>重置</Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Form.create()(Search);


// WEBPACK FOOTER //
// ./components/swbl/lstdtj/table/search.js